import { useContext, useEffect, useState } from 'react';
import { Title } from '../../components/Title/Title';
import { canvasBackgroundContext } from '../../context/canvasBackgroundContext';
import styles from './Base.module.css';
import { BaseElement } from './BaseElement/BaseElement';
import { Grid } from '@mui/material';
import { useTextureData } from "../../hooks/useTextureData";
import { collectionsContext } from "../../context/collectionsContext";

export const BaseContainer = () => {
  const { backgroundData } = useContext(canvasBackgroundContext);
  const [currentBase, setCurrentBase] = useState<string>();
  const { collectionsData } = useContext(collectionsContext);
  const [textureData] = useTextureData(collectionsData.elementId);

  useEffect(() => {
    if (!currentBase) setCurrentBase(backgroundData.groupName);
  }, [backgroundData]);

  useEffect(() => {
    setCurrentBase(backgroundData.groupName);
  }, [collectionsData]);

  return (
    <div>
      <Grid display="grid" gap="20px">
        <div className={styles.baseTitle}>
          <Title>Материал и цвет основы</Title>
        </div>
        <div>
          <Grid
              id={'baseContainer'}
              className={styles.baseContainer}
              display="grid"
              gridTemplateColumns="repeat(3, 1fr)" gap="12px"

          >
            {backgroundData.items.map((item, key) => {
              item.colors.concat(item.premColors);
              const name = item.colors.find(color => color.img === item.selectedImg) && item.colors.find(color => color.img === item.selectedImg)?.name
                  ? item.colors.find(color => color.img === item.selectedImg)?.name
                  : item.premColors.find(color => color.img === item.selectedImg) && item.premColors.find(color => color.img === item.selectedImg)?.name
                      ? item.premColors.find(color => color.img === item.selectedImg)?.name
                      : item.colors[0] && item.colors[0]?.name
                          ? item.colors[0]?.name
                          : item.premColors[0] && item.premColors[0]!.name
                              ? item.premColors[0]!.name
                              : ''
              ;

              if(!textureData?.remove_background?.includes(+item.id)) {
                return (
                    <BaseElement
                        key={item.id}
                        name={item.groupName}
                        selectedBackgroundName={name ? name : ''}
                        // img={item.selectedImg ? item.selectedImg : item.colors[0].img}
                        img={item.selectedImg
                            ? item.selectedImg
                            : item.groupName == backgroundData.groupName
                              ? backgroundData.img
                              : item.colors[0].img}
                        price={item.price}
                        selectedColorPicker={ (backgroundData.name.includes('%23') || backgroundData.name.includes('#')) ? backgroundData.name.replace('%23', '#') : ''}
                        selected={currentBase === item.groupName}
                        onSelect={() => setCurrentBase(item.groupName)}
                        id={item.id}
                        isPrem={item.isPrem}
                        premPrice={item.premPrice}
                        keyProp={key}
                        backgroundDataName={backgroundData.name}
                    />
                );
              } else {
                return null;
              }
            })}
          </Grid>
        </div>
      </Grid>
    </div>
  );
};
